module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "scene",
    style: (_vm.sceneStyle),
    attrs: {
      "id": "tunnel-scene"
    }
  }, [_c('div', {
    staticClass: "wrapper",
    style: (_vm.wrapperStyle)
  }, [_c('ul', {
    staticClass: "tunnel"
  }, _vm._l((_vm.countDivs), function(n) {
    return _c('li', {
      staticClass: "ring",
      style: (_vm.ringStyle)
    })
  }))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-f06f484e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tunnel.vue
// module id = 129
// module chunks = 1